import { ShippingMethod } from './ShippingMethod';
import { LineItem } from './LineItem';
import { Address } from '../account/Address';
import { Payment } from './Payment';
import { Discount } from './Discount';
import { Tax } from './Tax';
import { ShippingInfo } from './ShippingInfo';
import { Money } from '../product/Money';
import { AdjustmentHistory, NotesDetailsObjectType } from '../../backend/types/cart';
import { Availability } from '../product/InventoryQuery';
import { SOACustomer } from '../soa/customer/SoaCustomer'

export enum ORDER_TYPES {
  NO_CHARGE = 'noCharge',
  MAIL_ORDER = 'mailOrder',
  NEW_ORDER = 'newOrder',
}
export interface Cart {
  cartId: string;
  cartVersion?: string;
  lineItems?: LineItem[];
  email?: string;
  shippingInfo?: ShippingInfo; // Info of the shipping method selected by the customer
  availableShippingMethods?: ShippingMethod[]; // Available shipping methods for this cart
  shippingAddress?: Address;
  billingAddress?: Address;
  sum?: Money;
  payments?: Payment[];
  discountCodes?: Discount[];
  taxed?: Tax;
  totalPrice?: Money;
  cartState?: string;
  orderType?: ORDER_TYPES;
  taxMode?: string;
  additionalDetails?: {
    notes: NotesDetailsObjectType;
    omsCustomerId?: string;
    adjustmentsHistory: Array<AdjustmentHistory>;
    orderType?: string;
    divisionCode?: string;
  };
  directDiscounts?: any;
  omsCustomerId?: string;
  subTotal?: Money;
  discountOnTotalPrice?: {
    discountedAmount?: Money;
  };
  totalTaxedPrice?: Money;
  cartTotal?: Money; // subtotal - discount - especially to display in cart
  total?: Money; // sum is confusing so introduced this - lineItems total + shipping + tax - disc
  actualShippingAmount?: Money;
  shippingSurcharge?: Money;
  isTypeSetOnCart?: boolean;
  noChargeItemPresent?: boolean;
  selectedShippingMethod?: string;
  customLineItem?: LineItem[];
  cartDiscounts?: Discount[];
  // TODO: import the logic from Cart.php

  birthday?: Date;

  discountTotal?: Money;

  discount?: Money;

  totalPriceCalculated?: any;
  shippingAmount?: Money;
  specialShipping?: boolean;
  ipAddress?: string;
  fraudStatus?: string;
  fraudResponse?: string;
  checkoutStep?: number;
  paymentDetails?: any;
  shippingDiscount?: Money;
  orderNumber?: string;
  includedDiscounts?: IncludedDiscount[];
  giftNotes?: string;
  taxedGross?: Money;

  displayExcludedBrandMessage?: boolean;
  paymentType?: string;
  containsPOBoxItem?: boolean;
  fraudFields?: FraudFields;
  containsOnlyDropShipItems?: boolean;
  containsOnlyPersonalizedItems?: boolean;
  containsOnlyDropShipAndPersonalizedItems?: boolean;

  soaCustomerDetails?: SoaCustomerDetails;
  lastModifiedDate?: string;
  currentAdjustment?: any;
  stateNotAvail?: string[];
  containsInsuranceItem?: boolean;
}

export interface PersonalizeOptions {
  personalizeText?: string;
  personalizeProductId?: string;
  personalizeUserId?: string;
}

export interface FraudFields {
  score?: string;
  bcnTid?: string;
  bcnToken?: string;
  bcnEvents?: string;
  bcnUbaSessionId?: string;
  bcnPageId?: string;
  dvcTransactionPayload?: string;
  userAgent?: string;
}

export interface WarrantyOptions {
  isWarrantySelected?: boolean;
  sku?: string;
  lineItemId?: string;
  count?: number;
  id?: string;
}
export interface FilteredDiscountCodeCart {
  cart: Cart;
  isDiscountRemoved?: boolean;
}

export interface IncludedDiscount {
  discountId?: string;
  discountedAmount?: Money;
}

export interface CartAndError {
  cart: Cart;
  errorMessage: string;
}

export interface SoaCustomerDetails {
  soaCustomer: SOACustomer;
  soaCustomerVersion: string;
  lastModifiedDate: string;
}

export interface CartNotification {
  availabilityMessage?: Availability[];
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export type DateMap = Map<string, DateRange>;
